import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "subtitle hidden-lg" }
const _hoisted_3 = {
  key: 0,
  class: "chat-title"
}
const _hoisted_4 = {
  key: 1,
  class: "mobile-chat"
}
const _hoisted_5 = { class: "table" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Search = _resolveComponent("Search")!
  const _component_ChatMessages = _resolveComponent("ChatMessages")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_Page = _resolveComponent("Page")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      (_ctx.isMounted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_Teleport, { to: "#headerSlot" }, [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_TranslatedText, { path: "chat.title" })
              ])
            ])),
            _createVNode(_component_Page, {
              title: _ctx.pageTitle,
              navItems: _ctx.filteredResults,
              activeItem: _ctx.activeNavItem,
              avatar: _ctx.getAvatar,
              showTabList: _ctx.isMobile ? false : true,
              showNavItemIconRight: false,
              showNavItemAvatar: true,
              showNavItemSubtitle: true
            }, {
              back: _withCtx(() => [
                _createElementVNode("div", null, [
                  (!_ctx.activeChatUserId || !_ctx.isMobile)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_3, [
                        _createVNode(_component_TranslatedText, { path: "chat.title" })
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "back-link",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeChat && _ctx.closeChat(...args)))
                      }, [
                        _cache[1] || (_cache[1] = _createTextVNode(" < ", -1)),
                        _createVNode(_component_TranslatedText, { path: "chat.back" })
                      ]))
                ])
              ]),
              header: _withCtx(() => [
                (!_ctx.isMobile || !_ctx.activeChatUserId)
                  ? (_openBlock(), _createBlock(_component_Search, {
                      key: 0,
                      id: "search-chatable-users",
                      searchOpen: "",
                      onFilterSearch: _ctx.handleUpdateSearchTerm,
                      class: "style-standard h-pad"
                    }, null, 8, ["onFilterSearch"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (!_ctx.isMobile || _ctx.activeChatUserId)
                  ? (_openBlock(), _createBlock(_component_ChatMessages, {
                      key: 0,
                      activeChatMessages: _ctx.activeChatMessages,
                      onAddNewMessage: _ctx.addNewMessage
                    }, null, 8, ["activeChatMessages", "onAddNewMessage"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (!_ctx.activeChatUserId)
                          ? (_openBlock(), _createBlock(_component_TableList, {
                              key: 0,
                              tableName: "chat"
                            }, {
                              colspan: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("colgroup", null, [
                                  _createElementVNode("col", { style: {"width":"15%"} }),
                                  _createElementVNode("col", { style: {"width":"80%"} }),
                                  _createElementVNode("col", { style: {"width":"5%"} })
                                ], -1)
                              ]))]),
                              body: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredResults, (user) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: user.id,
                                    onClick: ($event: any) => (_ctx.openChat(user.id))
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Avatar, {
                                        size: "sm",
                                        image: _ctx.getUserImage(user),
                                        alt: user.title,
                                        text: _ctx.getUserInitials(user)
                                      }, null, 8, ["image", "alt", "text"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("h5", null, _toDisplayString(user.title), 1),
                                      _createElementVNode("p", null, _toDisplayString(user.subtitle), 1)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "chevron-right",
                                        size: "lg"
                                      })
                                    ])
                                  ], 8, _hoisted_6))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_ChatMessages, {
                              key: 1,
                              activeChatMessages: _ctx.activeChatMessages,
                              onAddNewMessage: _ctx.addNewMessage
                            }, null, 8, ["activeChatMessages", "onAddNewMessage"]))
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["title", "navItems", "activeItem", "avatar", "showTabList"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}